module.exports = __webpack_public_path__ + "static/media/upload.fed4a4c3.svg";